import Emittery from 'emittery';
/**
 * # @deprecated 請見 {@link EventWhyThisDeprecated}
 *
 * @deprecated
 */
export const eventEmitter = new Emittery();
